import React from "react";
import { Outlet } from "react-router-dom";

const ContentManagement: React.FC = () => {
    return <Outlet />;
};

export default ContentManagement;
